import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  CloseButton,
  TextInputField,
  TextInputFieldSearch,
} from "../../../../../../components/atoms";
import { ItemReportDisplay } from "./components";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import { CalenderSelector, LoadingPopUp } from "../../../../../../components";
import JsPDF from "jspdf";

const InventoryDisplay = ({ auth, storeArray }) => {
  const { width, height } = useWindowDimensions();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedInventoryProduct, setSelecetdInventoryProduct] =
    useState(null);

  const [loading, setLoading] = useState(false);

  const [popUpHover, setPopUpHover] = useState(false);
  // store variables
  const [selectedStore, setSelectedStore] = useState("");

  const [inventoryItemsArray, setInventoryItemsArray] = useState(null);
  const [productItemsArray, setProductItemsArray] = useState(null);
  const [recipetsArray, setRecipetsArray] = useState(null);
  const [stockTakeTickets, setStocktakeTickets] = useState([]);
  const [transfersArray, setTransferArray] = useState([]);
  const [dateSelectorPopUp, setDateSelectorPopUp] = useState(false);
  const [dateSelection, setDateSelection] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [soldProductItems, setSoldProductItems] = useState([]);

  const [customDay, setCustomDay] = useState("1");
  const [periodOpen, setPeriodOpen] = useState(false);
  const [period, setPeriod] = useState("");
  const [periodSelected, setPeriodSelected] = useState("Custom");

  const [startingDate, setStartingDate] = useState(new Date());

  const [startingDay, setStartingDay] = useState(
    new Date().toISOString().substring(8, 10)
  );
  const [startingMonth, setStartingMonth] = useState(
    new Date().toISOString().substring(5, 7)
  );
  const [startingYear, setStartingYear] = useState(
    new Date().toISOString().substring(0, 4)
  );

  const [selectedItemrecipetsArray, setselectedItemrRecipetsArray] = useState(
    []
  );
  const [selectedItemrstockTakeTickets, setselectedItemrStocktakeTickets] =
    useState([]);
  const [selectedItemrtransfersArray, setselectedItemrtransfersArray] =
    useState([]);
  const [selectedItemFullTransferArray, setselectedItemFullTransferArray] =
    useState([]);
  const [selectedItemFullReceipt, setselectedItemFullReceipt] = useState([]);

  const [amountSales, setAmountSales] = useState(null);
  const [amountSalesvalue, setAmountSalesValue] = useState(null);

  const [search, setSearch] = useState("");
  const [textSearch, setTextSearch] = useState("");

  // date display array

  const [dateArrayDisplay, setDateArrayDisplay] = useState(null);

  const NameAssemble = ({ productId }) => {
    let product;
    let name = "none found";

    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (product = item) : null
      );
    }

    if (product) {
      name =
        product.productName +
        " | " +
        product.productSubType +
        " | " +
        product.thcType +
        " | " +
        product.thcContent;
      return name;
    }
    return name;
  };

  const selectProductCheck = ({ productId }) => {
    setLoading(true);
    let product;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (product = item) : null
      );
    }

    if (product) {
      setLoading(false);
      return product;
    }
  };
  const ReturnProductNameIdAndSuccessDisplay = ({ productId }) => {
    let productIdCheck;
    let productName;
    let display = false;
    if (soldProductItems) {
      // soldProductItems.map((item) =>
      //   item.product._id === productId
      //     ? (productId = item.product.productId)
      //     : null
      // );
      for (let index = 0; index < soldProductItems.length; index++) {
        const element = soldProductItems[index];
        if (element.product._id === productId) {
          productIdCheck = element.product.productId;
          productName = element.product.productName;
          display = true;
        }
      }
    }

    return {
      productId: productIdCheck,
      productName: productName,
      display: display,
    };
  };
  // get inventory reporting base\
  const getInventoryData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/reportingStats/getInventoryDataList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: auth.userId,
            storeId:
              selectedStore === "ALL" ||
              selectedStore === "warehouse" ||
              !selectedStore
                ? selectedStore
                : selectedStore.storeId,
            storeName:
              selectedStore === "ALL" ||
              selectedStore === "warehouse" ||
              !selectedStore
                ? selectedStore
                : selectedStore.storeName,
            storeRoughId: selectedStore._id,
            productName: "none",
            productId: "none",
            startingDate: {
              day: Number(startingDay),
              month: Number(startingMonth),
              year: Number(startingYear),
            },
            period: customDay,
            type: "Admin",
          }),
        }
      );
      const respnseData = await response.json();
      console.log("response inventory data list", respnseData);
      if (respnseData.success) {
        setInventoryItemsArray(respnseData.inventoryArray);
        setProductItemsArray(respnseData.listOfProducts);
        setRecipetsArray(respnseData.dateRangeReceipts);
        setStocktakeTickets(respnseData.stockTakeTicketsArray);
        setTransferArray(respnseData.letAllTransfers);
        setSoldProductItems(respnseData.soldProducts);
        setDateArrayDisplay(respnseData.dateArray);
        setLoading(false);
        // setStoreArray(respnseData.stores);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("test", err);
    }
  };
  const getSalesItemAmountAndValue = ({ productId }) => {
    let qtyAmount = [];
    let stock = 0;

    // console.log("chcek data in side amount chcek");

    for (let index = 0; index < selectedItemrecipetsArray.length; index++) {
      const element = selectedItemrecipetsArray[index];

      qtyAmount.push(Number(element.qtyCard.qty));
    }

    let qtyAmountSld = qtyAmount.reduce(function (x, y) {
      return x + y;
    }, 0);

    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId ? (stock = item.retailPriceInc) : null
      );
    }

    let amount = stock * qtyAmountSld;

    // if (amount === 0) {
    //   setAmountSales("0.00");
    //   setAmountSalesValue("0.00");
    //   return { amount: amount, qtyAmount: qtyAmountSld };
    // }

    setAmountSalesValue(qtyAmountSld);
    setAmountSales(amount);

    return { amount: amount, qtySold: qtyAmountSld };
  };

  const getSalesItemAmountAndValueLiveCheck = ({ productId }) => {
    let qtyAmount = [];
    let stock = 0;

    // console.log("chcek data in side amount chcek");

    for (let index = 0; index < recipetsArray.length; index++) {
      const element = recipetsArray[index];

      for (let i = 0; i < element.productsArray.length; i++) {
        const elementItem = element.productsArray[i];
        if (elementItem.qtyCard.productId === productId) {
          qtyAmount.push(Number(elementItem.qtyCard.qty));
        }
      }
    }

    let qtyAmountSld = qtyAmount.reduce(function (x, y) {
      return x + y;
    }, 0);

    // if (productItemsArray) {
    //   productItemsArray.map((item) =>
    //     item._id === productId ? (stock = item.retailPriceInc) : null
    //   );
    // }

    let amount = qtyAmountSld;

    // if (amount === 0) {
    //   setAmountSales("0.00");
    //   setAmountSalesValue("0.00");
    //   return { amount: amount, qtyAmount: qtyAmountSld };
    // }

    // setAmountSalesValue(qtyAmountSld);
    // setAmountSales(amount);

    return { amount: amount };
  };
  const ReturnStockAmount = ({ productId, qty }) => {
    let stock = 0;
    if (productItemsArray) {
      productItemsArray.map((item) =>
        item._id === productId
          ? (stock = item.baseCostPrice.replace(/\\|\,/g, "."))
          : null
      );
    }

    let amount = stock * qty;

    if (qty === 0) {
      return String(0.0);
    }

    return String(Number(amount).toFixed(2));
  };

  //   console.log("selectedItemrtransfersArray", selectedItemrtransfersArray);

  //   console.log("selectedItemrstockTakeTickets", selectedItemrstockTakeTickets);
  //   console.log("selectedItemrecipetsArray", selectedItemrecipetsArray);
  //   console.log("selectedItemFullTransferArray", selectedItemFullTransferArray);

  const returnProductTransfers = ({ productId }) => {
    if (transfersArray) {
      for (let index = 0; index < transfersArray.length; index++) {
        const element = transfersArray[index];

        for (let i = 0; i < element.productsArray.length; i++) {
          const elementItem = element.productsArray[i];
          if (elementItem.qtyCard.productId === productId) {
            selectedItemrtransfersArray.push(elementItem);
            selectedItemFullTransferArray.push(element);
          }
        }
      }
    }
    return selectedItemrtransfersArray;
  };

  const returnProductReceipts = ({ productId }) => {
    setLoading(true);

    if (recipetsArray && selectedStore !== "warehouse") {
      for (let index = 0; index < recipetsArray.length; index++) {
        const element = recipetsArray[index];

        for (let i = 0; i < element.productsArray.length; i++) {
          const elementItem = element.productsArray[i];
          if (elementItem.qtyCard.productId === productId) {
            selectedItemrecipetsArray.push(elementItem);
            selectedItemFullReceipt.push(element);
          }
        }
      }
    }
    setLoading(false);
    return selectedItemrecipetsArray;
  };

  const returnStockTakeTickets = ({ productId }) => {
    if (stockTakeTickets) {
      for (let index = 0; index < stockTakeTickets.length; index++) {
        const element = stockTakeTickets[index];

        if (element.productId === productId) {
          selectedItemrstockTakeTickets.push(element);
        }
      }
    }
    if (selectedItemrecipetsArray.length === 0) {
      setLoading(false);
    }
    return selectedItemrstockTakeTickets;
  };

  const generatePDF = async () => {
    // prescriptionPdf();

    const report = await new JsPDF("portrait", "px", [794, 1123]);
    report.html(document.querySelector("#reportInventory")).then(() => {
      report.getFontList();
      report.save(
        `${
          selectedStore.storeName
        } ${new Date().toLocaleDateString()} stock report.pdf`
      );
    });
  };
  const StockSheet = () => {
    return (
      <div
        id="reportInventory"
        style={{
          fontFamily: "Arial",
          position: "absolute",
          zIndex: -1,
          width: 794,
          backgroundColor: BlackAndWhite.secondary,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowX: "hidden",
        }}
      >
        {/* // header base info */}
        <div
          style={{
            minHeight: 100,
            width: "100%",
            display: "flex",
            alignItems: "center",
            // marginTop: 3,
            maxWidth: 794,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 14,
                fontWeight: "bold",
                color: "#5F6469",
                marginLeft: 20,
                marginTop: 5,
              }}
            >
              STOCK SHEET -{" "}
              {selectedStore ? selectedStore.storeName : "loading"}
            </div>
            <div style={{ fontSize: 12, marginLeft: 20, marginTop: 5 }}>
              {dateArrayDisplay
                ? dateArrayDisplay.length >= 2
                  ? dateArrayDisplay[dateArrayDisplay.length - 1].substring(
                      0,
                      10
                    ) +
                    " to " +
                    dateArrayDisplay[0].substring(0, 10)
                  : dateArrayDisplay[0].substring(0, 10)
                : "loading"}
            </div>
          </div>
          <div style={{ flex: 1 }} />
          <div
            style={{
              marginRight: 20,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                marginTop: 5,
                fontSize: 12,
                fontWeight: "bold",
                color: "#5F6469",
                marginLeft: 10,
              }}
            >
              {" "}
              TIME REQUESTED
            </div>
            <div
              style={{
                fontSize: 14,
                marginLeft: 10,
                color: "#000000",
                marginTop: 5,
              }}
            >
              {new Date().toLocaleTimeString()}
            </div>
          </div>
        </div>
        {/* list header */}
        <div
          style={{
            width: "80%",
            maxWidth: 750,
            minWidth: 750,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontSize: 10,
            borderStyle: "solid",
            paddingTop: 5,
            paddingBottom: 5,
            borderColor: "#CBD1D8",
            backgroundColor: "#CBD1D8",
          }}
        >
          <div style={{ flex: 0.7, display: "flex", alignItems: "center" }}>
            <div style={{ marginLeft: 10 }}>PRODUCT NAME</div>
          </div>
          <div style={{ flex: 0.15, display: "flex", alignItems: "center" }}>
            SOLD QTY
          </div>
          <div style={{ flex: 0.15, display: "flex", alignItems: "center" }}>
            HOLDING
          </div>
        </div>
        {inventoryItemsArray ? (
          inventoryItemsArray.map((item, index) => {
            return NameAssemble({ productId: item.productId }) !==
              "none found" &&
              (item.lifeTimeOfProductBroughtIn >= 1 ||
                Number(item.currentStock).toFixed(2) >= 0.001) ? (
              NameAssemble({ productId: item.productId })
                .toLowerCase()
                .match(textSearch.toLowerCase()) &&
              ReturnProductNameIdAndSuccessDisplay({
                productId: item.productId,
              }).display === true ? (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedProduct(
                      selectProductCheck({ productId: item.productId })
                    );
                    setSelecetdInventoryProduct(item);
                  }}
                  style={{
                    width: 750,
                    maxWidth: 750,
                    minWidth: 750,
                    minHeight: 30,
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderColor: "#00000050",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: BlackAndWhite.secondary,
                  }}
                >
                  <div
                    style={{
                      flex: 0.7,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{ width: "100%", display: "flex", fontSize: 10 }}
                    >
                      <div style={{ minWidth: 20 }} />
                      {NameAssemble({ productId: item.productId }) ===
                      "none found"
                        ? item.productName
                        : NameAssemble({ productId: item.productId })}
                    </div>
                  </div>

                  {/* <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />R{" "}
                      {ReturnStockAmount({
                        productId: item.productId,
                        qty: item.currentStock,
                      })}
                    </div>
                  </div> */}
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />
                      {String(
                        getSalesItemAmountAndValueLiveCheck({
                          productId: item.productId,
                        }).amount
                      )}
                      {/* {ReturnSalesAmount({ productId: item.productId })} */}
                      {/* {item.lifeTimeOfProductBroughtIn} */}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />
                      {Number(item.currentStock).toFixed(2)}
                    </div>
                  </div>
                </div>
              ) : null
            ) : null;
          })
        ) : (
          <div>LOADING...</div>
        )}
      </div>
    );
  };
  const returnData = () => {
    return {
      selectedItemrtransfersArray: selectedItemrtransfersArray,
      selectedItemrstockTakeTickets: selectedItemrstockTakeTickets,
      selectedItemrecipetsArray: selectedItemrecipetsArray,
    };
  };
  console.log("dateArrayDisplay", dateArrayDisplay);
  // set period and get data over period
  useEffect(() => {
    // here is where the approval fileds will be added for review
    if (selectedStore) {
      getInventoryData();
    }
  }, [selectedStore, refresh]);

  useEffect(() => {
    // here is where the approval fileds will be added for review
    if (selectedProduct) {
      //   getInventoryData();

      returnProductTransfers({ productId: selectedProduct._id });
      returnStockTakeTickets({ productId: selectedProduct._id });
      getSalesItemAmountAndValue({ productId: selectedProduct._id });
      if (selectedItemrecipetsArray) {
        returnProductReceipts({ productId: selectedProduct._id });
      }

      returnData();
    } else if (!selectedProduct) {
      setselectedItemrtransfersArray([]);
      setselectedItemrStocktakeTickets([]);
      setSelecetdInventoryProduct(null);
      setselectedItemrRecipetsArray([]);
      setAmountSales(null);
      setAmountSalesValue(null);
      setselectedItemFullReceipt([]);
      setselectedItemFullTransferArray([]);
    }
  }, [selectedProduct]);
  useEffect(() => {
    if (startingDate) {
      //this is the day check
      setStartingDay(startingDate.toISOString().substring(8, 10));

      //this is the month check
      setStartingMonth(startingDate.toISOString().substring(5, 7));

      //this is the year check
      setStartingYear(startingDate.toISOString().substring(0, 4));
    }
  }, [startingDate]);
  useEffect(() => {
    // here is where the approval fileds will be added for review
    if (amountSales === 0 && selectedProduct) {
      //   getInventoryData();

      getSalesItemAmountAndValue({ productId: selectedProduct._id });
    } else {
      return;
    }
  }, [amountSales]);
  return (
    <div
      style={{
        height: height - 70,
        width: width,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          minHeight: 50,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 5 }} />
        <TextInputFieldSearch
          height={28}
          borderRadius={4}
          placeholder={"search product here"}
          onChange={(e) => setTextSearch(e.target.value)}
          value={textSearch}
        />
        <BaseButtons
          label={"CLEAR"}
          mini={true}
          borderRadius={4}
          size={80}
          marginTopFalse={true}
          height={35}
          marginLeft={5}
          onClick={() => {
            setTextSearch("");
            setSearch("");
          }}
        />
        <BaseButtons
          label={"SEARCH"}
          mini={true}
          borderRadius={4}
          size={80}
          marginTopFalse={true}
          height={35}
          marginLeft={5}
          onClick={() => {
            setSearch(textSearch);
          }}
        />

        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"DOWNLOAD"}
          mini={true}
          minHeight={40}
          height={40}
          marginTopFalse={true}
          borderRadius={8}
          onClick={() => generatePDF()}
          // marginTop={5}
          // disable={periodSelected === "2" ? true : false}
          // onClick={
          //   periodSelected === "2"
          //     ? null
          //     : () => setDateSelectorPopUp(true)
          // }
        />
        <BaseButtons
          label={"REFRESH"}
          mini={true}
          borderRadius={4}
          size={80}
          marginTopFalse={true}
          height={35}
          marginLeft={5}
          onClick={() => {
            setRefresh(refresh ? false : true);
          }}
        />
        <div style={{ marginLeft: 10, marginRight: 10 }}>
          <div style={{ marginBottom: 5, fontSize: 12 }}>
            {dateArrayDisplay
              ? dateArrayDisplay.length >= 2
                ? dateArrayDisplay[dateArrayDisplay.length - 1].substring(
                    0,
                    10
                  ) +
                  " to " +
                  dateArrayDisplay[0].substring(0, 10)
                : dateArrayDisplay[0].substring(0, 10)
              : "loading"}
          </div>
          <div style={{ fontWeight: "bold", fontSize: 9 }}>VIEW PERIOD</div>
        </div>

        <div
          style={{
            height: 50,
            // borderStyle: "solid",
            // width: 200,
            marginRight: 10,
            paddingLeft: 10,
            paddingRight: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ marginRight: 10, display: "flex" }}>
            {dateSelectorPopUp ? (
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    position: "absolute",
                    zIndex: 2000,
                    top: -5,
                    left: -5,
                  }}
                >
                  <CloseButton
                    label={"X"}
                    invert={true}
                    height={40}
                    width={40}
                    onClick={() => setDateSelectorPopUp(false)}
                  />
                </div>
                <CalenderSelector
                  startingDate={startingDate}
                  setStartingDate={setStartingDate}
                  setDateSelectorPopUp={setDateSelectorPopUp}
                />
              </div>
            ) : (
              <div>
                {/* <div
                            style={{
                              fontSize: 10,
                              opacity: 0.6,
                              fontWeight: "bold",
                              width: "100%",
                              marginBottom: 3,
                            }}
                          >
                            DATE SELECTOR
                          </div> */}
                <BaseButtons
                  label={startingDate.toDateString()}
                  mini={true}
                  minHeight={40}
                  height={40}
                  marginTopFalse={true}
                  borderRadius={8}
                  // marginTop={5}
                  disable={periodSelected === "2" ? true : false}
                  onClick={
                    periodSelected === "2"
                      ? null
                      : () => setDateSelectorPopUp(true)
                  }
                />
              </div>
            )}
          </div>
          <div style={{ position: "relative" }}>
            {/* <BaseButtons
              label={`${periodSelected} days`}
              mini={true}
              marginTopFalse={true}
              // borderRadius={8}
              marginRight={periodSelected === "Custom" ? 10 : 0}
              minHeight={55}
              height={55}
              size={120}
              invert={false}
              onClick={() => {
                setPeriodOpen(true);
              }}
            /> */}
            <div
              style={{
                display: "flex",
                height: periodOpen ? 200 : 0,
                // borderStyle: "solid",
                flexDirection: "column",
                zIndex: 10000000000000,
                position: "absolute",
                overflow: "hidden",
                alignItems: "center",
                width: 120,
              }}
            >
              <BaseButtons
                label={"TODAY"}
                mini={true}
                marginTop={4}
                // borderRadius={8}
                // marginRight={10}
                minHeight={30}
                height={30}
                size={"100%"}
                invert={periodSelected === "1" ? false : true}
                onClick={() => {
                  setPeriodSelected("1");
                  setStartingDate(new Date());
                  setPeriodOpen(false);
                }}
              />
              {/* <BaseButtons
                          label={"YESTERDAY"}
                          mini={true}
                          marginTop={4}
                          // borderRadius={8}
                          // marginRight={10}
                          minHeight={30}
                          height={30}
                          size={"100%"}
                          invert={periodSelected === "2" ? false : true}
                          onClick={() => {
                            setPeriodSelected("2");
                            setStartingDate(new Date());
                            setPeriodOpen(false);
                          }}
                        /> */}
              <BaseButtons
                label={"7 DAYS"}
                mini={true}
                // marginTop={1}
                marginTopFalse={true}
                // borderRadius={8}
                // marginRight={10}
                minHeight={30}
                height={30}
                size={"100%"}
                invert={periodSelected === "7" ? false : true}
                onClick={() => {
                  setPeriodSelected("7");
                  setPeriodOpen(false);
                }}
              />
              <BaseButtons
                label={"30 DAYS"}
                mini={true}
                // marginTop={1}
                marginTopFalse={true}
                // borderRadius={8}
                // marginRight={10}
                minHeight={30}
                height={30}
                size={"100%"}
                invert={periodSelected === "30" ? false : true}
                onClick={() => {
                  setPeriodSelected("30");
                  setPeriodOpen(false);
                }}
              />
              <BaseButtons
                label={"CUSTOM"}
                mini={true}
                // marginTop={-1}
                marginTopFalse={true}
                // borderRadius={8}
                // marginRight={10}
                minHeight={30}
                height={30}
                size={"100%"}
                invert={periodSelected === "Custom" ? false : true}
                onClick={() => {
                  setPeriodOpen(false);
                  setPeriodSelected("Custom");
                }}
              />
            </div>
          </div>
          {periodSelected === "Custom" ? (
            <TextInputField
              mini={true}
              // labelTitle={"DAYS?"}
              height={17}
              fontsizeLabel={10}
              invert={true}
              marginTop={-2}
              size={80}
              type={"number"}
              placeholder={"DAYS e.g 1 or 7"}
              onChange={(e) => setCustomDay(String(e.target.value))}
              value={customDay}
            />
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
            position: "relative",
          }}
        >
          <div style={{ fontSize: 14, marginRight: 10 }}>STORE</div>
          <BaseButtons
            mini={true}
            marginTopFalse={true}
            height={30}
            label={
              selectedStore === "ALL" ||
              selectedStore === "warehouse" ||
              !selectedStore
                ? selectedStore
                : selectedStore.storeName
            }
            borderRadius={4}
            size={140}
            onClick={() => setSelectedStore(null)}
          />
        </div>
      </div>
      {/* // header */}
      <div
        style={{
          width: "100%",
          height: 40,
          backgroundColor: BlackAndWhite.primary,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            PRODUCT NAME
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            CURRENTLY HOLDING
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            HOLDING VALUE
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            SOLD QTY
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ minWidth: 20 }} />
            LAST STOCK CHECK
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: BlackAndWhite.secondary,
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "left",
          }}
        >
          <div>ACTIONS</div>
        </div>
      </div>
      <div
        style={{
          flex: 1,

          width: "100%",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {inventoryItemsArray ? (
          inventoryItemsArray.map((item, index) => {
            return NameAssemble({ productId: item.productId }) !==
              "none found" &&
              (item.lifeTimeOfProductBroughtIn >= 1 ||
                Number(item.currentStock).toFixed(2) >= 0.001) ? (
              NameAssemble({ productId: item.productId })
                .toLowerCase()
                .match(textSearch.toLowerCase()) &&
              ReturnProductNameIdAndSuccessDisplay({
                productId: item.productId,
              }).display === true ? (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedProduct(
                      selectProductCheck({ productId: item.productId })
                    );
                    setSelecetdInventoryProduct(item);
                  }}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderColor: "#00000050",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: BlackAndWhite.secondary,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{ width: "100%", display: "flex", fontSize: 12 }}
                    >
                      <div style={{ minWidth: 20 }} />
                      {NameAssemble({ productId: item.productId }) ===
                      "none found"
                        ? item.productName
                        : NameAssemble({ productId: item.productId })}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />
                      {Number(item.currentStock).toFixed(2)}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />R{" "}
                      {ReturnStockAmount({
                        productId: item.productId,
                        qty: item.currentStock,
                      })}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />
                      {String(
                        getSalesItemAmountAndValueLiveCheck({
                          productId: item.productId,
                        }).amount
                      )}
                      {/* {ReturnSalesAmount({ productId: item.productId })} */}
                      {/* {item.lifeTimeOfProductBroughtIn} */}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.15,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ width: "100%", display: "flex" }}>
                      <div style={{ minWidth: 20 }} />
                      {item.stockTakeDate}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: BlackAndWhite.primary,
                      fontSize: 12,
                      // fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      mini={true}
                      marginTopFalse={true}
                      height={30}
                      onClick={() =>
                        setSelectedProduct(
                          selectProductCheck({ productId: item.productId })
                        )
                      }
                    />
                  </div>
                </div>
              ) : null
            ) : null;
          })
        ) : (
          <div>LOADING...</div>
        )}
      </div>
      <ItemReportDisplay
        loading={loading}
        display={selectedProduct}
        setClose={setSelectedProduct}
        selectedItemrecipetsArray={selectedItemrecipetsArray}
        selectedItemrstockTakeTickets={selectedItemrstockTakeTickets}
        selectedItemrtransfersArray={selectedItemrtransfersArray}
        setSelecetdInventoryProduct={setSelecetdInventoryProduct}
        selectedInventoryProduct={selectedInventoryProduct}
        productItemsArray={productItemsArray}
        amountSales={amountSales}
        amountSalesvalue={amountSalesvalue}
        selectedItemFullTransferArray={selectedItemFullTransferArray}
        selectedItemFullReceipt={selectedItemFullReceipt}
      />
      {/* // store slection pop up */}
      {!selectedStore ? (
        <div
          onClick={popUpHover ? null : () => setSelectedStore("ALL")}
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#00000030",
            position: "absolute",
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onMouseOver={() => setPopUpHover(true)}
            onMouseOut={() => setPopUpHover(false)}
            style={{
              minWidth: 400,
              maxWidth: 400,
              paddingTop: 10,
              paddingBottom: 20,
              borderRadius: 4,
              backgroundColor: BlackAndWhite.secondary,
              maxHeight: 500,
              overflowY: "scroll",
              overflowX: "hidden",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              // right: 10,
              // top: 10,
              // position: "absolute",
            }}
          >
            <div
              style={{
                position: "fixed",
                top: height - 800,
                width: "100%",
                maxWidth: 400,
                minWidth: 400,
                minHeight: 50,
                backgroundColor: BlackAndWhite.secondary,
                borderRadius: 8,
                display: "flex",
                justifyContent: "center",
              }}
            >
              SEARCH BAR
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <BaseButtons
                label={"Warehouse"}
                mini={true}
                marginTopFalse={true}
                borderRadius={4}
                height={45}
                minHeight={45}
                size={"90%"}
                onClick={() => setSelectedStore("warehouse")}
              />
            </div>
            {storeArray
              ? storeArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        marginTop: index === 0 ? 0 : 10,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BaseButtons
                        label={item.storeName}
                        mini={true}
                        marginTopFalse={true}
                        borderRadius={4}
                        height={45}
                        minHeight={45}
                        size={"90%"}
                        onClick={() => setSelectedStore(item)}
                      />
                    </div>
                  );
                })
              : "no stores avlible"}
          </div>
        </div>
      ) : null}
      <LoadingPopUp display={loading} newWidth={"100%"} />
      {<StockSheet />}
    </div>
  );
};

export default InventoryDisplay;
